// extracted by mini-css-extract-plugin
export default {"root":"FlexibleQuotaBlock__root--12tFT"};